import annotations from './modules/annotations';
import auth from './modules/auth';
import counterpoint from './modules/counterpoint';
import document from './modules/document';
import general from './modules/general';
import geometries from './modules/geometries';
import hover from './modules/hover';
import organization from './modules/organization';
import outline from './modules/outline';
import team from './modules/team';
import user from './modules/user';
import share from './modules/share';
import status from './modules/status';
import logger from './modules/logger';

export default {
  ...annotations.mutations,
  ...auth.mutations,
  ...counterpoint.mutations,
  ...document.mutations,
  ...general.mutations,
  ...geometries.mutations,
  ...hover.mutations,
  ...organization.mutations,
  ...outline.mutations,
  ...team.mutations,
  ...user.mutations,
  ...share.mutations,
  ...status.mutations,
  ...logger.mutations,
};
